<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Account type (required):
          <br />
          <span class="disclaimer">
            Chosen by the Performance team depending on the campaign. For example,
            a Pical Resort campaign uses the Pical Resort FB Page, while a general
            campaign such as Black Friday uses the Valamar FB Page.
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p-select
            #accountTypeDropdown
            [options]="accountTypes"
            [(ngModel)]="selectedAccountType"
            [disabled]="disabled"
            [showClear]="true"
            [placeholder]="accountTypePlaceholder"
            [style]="{ width: '100%', zIndex: '3' }"
            [ngModelOptions]="{ standalone: true }"
            name="accountTypeDropdown"
            (onChange)="onChange($event.value ?? '', 'AccountType')"
          >
            <ng-template let-accountType pTemplate="item">
              <div class="dropdown-option">{{ accountType }}</div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
</main>
